const e = {
  name: "SolutionPlatformEngineering",
  dimensions: { width: 24, height: 24 },
  content: `
   <svg fill="currentColor">
    <g clip-path="url(#clip0_21_1800)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7072 6.29293C12.3167 5.9024 11.6836 5.9024 11.293 6.29293L6.29303 11.2929C5.90472 11.6812 5.9022 12.31 6.28737 12.7014L11.2274 17.7214C11.4139 17.911 11.6682 18.0184 11.9341 18.02C12.2001 18.0216 12.4557 17.9172 12.6444 17.7299L17.7044 12.7099C17.8932 12.5227 17.9996 12.2679 18.0001 12.002C18.0007 11.7361 17.8953 11.4809 17.7072 11.2929L12.7072 6.29293ZM11.9486 15.603L8.4087 12.0057L12.0001 8.41425L15.5831 11.9972L11.9486 15.603Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7077 0.293137C12.3172 -0.0973869 11.684 -0.0973869 11.2935 0.293137L0.29094 11.2957C-0.099584 11.6862 -0.0995843 12.3194 0.29094 12.7099L11.2935 23.7125C11.684 24.103 12.3172 24.103 12.7077 23.7125L23.7103 12.7099C24.1008 12.3194 24.1008 11.6862 23.7103 11.2957L12.7077 0.293137ZM2.41226 12.0028L12.0006 2.41446L21.589 12.0028L12.0006 21.5912L2.41226 12.0028Z"/>
    </g>
    <defs>
    <clipPath id="clip0_21_1800">
    <rect width="24" height="24" fill="currentColor"/>
    </clipPath>
    </defs>
    </svg>

  `
};
export {
  e as SolutionPlatformEngineering
};
